import { render, staticRenderFns } from "./ModalImportStudents.vue?vue&type=template&id=27788ed4&scoped=true&lang=pug&"
import script from "./ModalImportStudents.vue?vue&type=script&lang=ts&"
export * from "./ModalImportStudents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27788ed4",
  null
  
)

export default component.exports